import React from 'react'
import { getImageSrc } from '../../../helpers/getImageSrc'

type SelectItemType = {
  id?: number
  name?: string
  imageSrc?: string
  subjectId?: string
  displayName?: string
}

export const mapSelectItems = <T extends SelectItemType>(items: T[]) =>
  items.map((item) => {
    return {
      value: item?.subjectId || item?.id,
      key: item?.displayName || item?.name,
      icon: <img src={item?.imageSrc || getImageSrc('dealer-small')} />,
    }
  })
